export class PDM {
    id: any;
    descricao: any;
    quantidade: number;
    item: any;
    classe: any;
}
